import { render, staticRenderFns } from "./DashboardAssessments.vue?vue&type=template&id=0dc95f14&"
import script from "./DashboardAssessments.vue?vue&type=script&lang=js&"
export * from "./DashboardAssessments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports